import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Footer = () => {
  return (
    <footer
      id="footer"
      className={
        "section  " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : "bg-dark footer-text-light ")
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 align-self-center text-center text-lg-start">
            <p className="mb-0">
              © 2024{" "}
              <a
                href="/"
                className="link-underline link-underline-opacity-0-hover"
              >
                Pelada+
              </a>
              . Todos os direitos reservados.
            </p>
          </div>
          <div className="col-lg-6 align-self-center">
            <ul className="nav nav-separator nav-separator-light justify-content-center justify-content-lg-end">
              <li className="nav-item">
                {" "}
                <a
                  className="nav-link"
                  target="_blank"
                  href="https://www.imagemvida.com.br/politica-de-privacidade" rel="noreferrer"
                >
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
